import React, { useContext } from 'react';
import { Modal, TextStyle } from '@superops/ui-design-system';
import {
  CREATE_ARTICLE_ID,
  KB_ARTICLE_MODULE,
  POPOVER_CONTENT
} from '@nile/rmm/src/modules/knowledge-base/helper/constants';
import { getTranslatedText, useActivityTracker } from '@nile/components';
import { useIntl } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';
import { AccountClient } from '@nile/graphql';
import { DELETE_ARTICLE } from '@nile/rmm/src/modules/knowledge-base/graphql';
import { withRouter } from 'react-router-dom';
import TabContext from '@nile/mangifera/src/Contexts/TicketContext';

function ArticleAlert(props) {
  const intl = useIntl();
  const tabContext = useContext(TabContext);
  const {
    actionName,
    open,
    onClose,
    article,
    onArticleSave,
    postDeleteCallback
  } = props;
  const modalProps = POPOVER_CONTENT?.find((item) => item.key === actionName)
    ?.modalProps;

  const [loading, setLoading] = React.useState(false);

  const deleteArticle = async () => {
    setLoading(true);
    const parentCollection = article?.parent?.itemId;
    AccountClient.mutate({
      mutation: DELETE_ARTICLE,
      variables: {
        input: {
          article: { itemId: article?.itemId }
        }
      }
    })
      .then((res) => {
        setLoading(false);
        if (res?.data?.deleteKbArticle) {
          if (postDeleteCallback) {
            postDeleteCallback();
            return;
          }
          tabContext.closeTab();
          setTimeout(() => {
            tabContext.openTab({
              module: 'IT_DOCS',
              id: 'itDocs',
              url: `/kb/collection/${parentCollection}`
            });
          }, 30);
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const handleActions = () => {
    switch (actionName) {
      case 'duplicate':
        (() => {
          useActivityTracker({
            event: 'KB_ARTICLE_DUPLICATE'
          });
          tabContext.openTab({
            module: KB_ARTICLE_MODULE,
            url: `/kb/article/${CREATE_ARTICLE_ID}/create`,
            data: {
              id: CREATE_ARTICLE_ID,
              isCloned: true
            },
            state: {
              ...article,
              name: `${article?.name} - ${getTranslatedText(
                intl,
                'client.new.workingTime.copy'
              )}`,
              itemId: CREATE_ARTICLE_ID,
              isCloned: true
            }
          });
        })();
        break;
      case 'unpublish':
        (() => {
          useActivityTracker({
            event: 'KB_ARTICLE_UNPUBLISH'
          });
          onArticleSave({ articleProps: { status: 'DRAFT' } });
          onClose();
        })();
        break;
      case 'delete':
        deleteArticle();
        break;
      default:
        break;
    }
  };

  return (
    <Modal
      dialogClassName="alert-modal article-actions"
      open={open}
      onClose={onClose}
      variant="confirmation"
      title={getTranslatedText(intl, modalProps?.title || 'app.noData.message')}
      showCloseButton={false}
      iconSize="lg"
      primaryAction={{
        destructive: modalProps?.destructive || false,
        content: (
          <span className="fx actr g5">
            {modalProps?.primaryIcon && (
              <SVGIcon name={modalProps?.primaryIcon} />
            )}
            <TextStyle>
              {getTranslatedText(
                intl,
                modalProps?.primaryLabel || 'app.noData.message'
              )}
            </TextStyle>
          </span>
        ),
        onAction: handleActions,
        loading: loading
      }}
      secondaryActions={[
        {
          content: getTranslatedText(intl, 'common.no'),
          onClick: onClose
        }
      ]}
    >
      <div className="mbt10">
        {getTranslatedText(
          intl,
          modalProps?.description || 'app.noData.message'
        )}
      </div>
    </Modal>
  );
}

export default withRouter(ArticleAlert);
